<template>
  <div class="component-name">
    <b-field>
      <textarea
        v-model="answer"
        :class="['curved-border is-size-5 is-heavy p-2', adminAnswer ? 'read-only' : '']"
        :placeholder="placeholder ? placeholder : 'Answer here'"
        :style="{
          backgroundColor: $root.$data.COLORS.neutral[3],
          borderColor: 'transparent',
          resize: 'none',
          width: '100%',
          minHeight: '200px',
          height: height ? height : 'auto',
        }"
        :readonly="!isEditable"
        @input="$emit('answered', answer)"
      />
    </b-field>
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'

export default {
  name: 'ComponentName',
  components: { /* Subcomponents */ },
  props: ['placeholder', 'default', 'height', 'isEditable', 'prevAnswer', 'adminAnswer'],
  data() {
    return { answer: '' };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
    adminAnswer() {
      this.answer = this.getInitAnswer();
    },
  },
  beforeCreate() {},
  created() {},
  mounted() {
    this.answer = this.getInitAnswer();
  },
  updated() {},
  methods: {
    getInitAnswer() {
      if (this.adminAnswer) return this.adminAnswer;
      if (this.prevAnswer) return this.prevAnswer;
      if (this.default) return this.default;
      return '';
    },
  },
};
</script>


<style scoped>
.read-only {
  cursor: default;
  color: gray;
}
</style>
